module.exports = __webpack_public_path__ + "img/charity_growth.a92a8638.jpg";